import { apiClient } from './client';

export interface ChatCommand {
  id: string;
  name: string;
  command: string;
  message: string;
  active: boolean;
}

export const commandsApi = {
  list: async (): Promise<ChatCommand[]> => {
    const { data } = await apiClient.get('/admin/commands');
    return data as ChatCommand[];
  },
  replace: async (commands: ChatCommand[]): Promise<ChatCommand[]> => {
    const { data } = await apiClient.put('/admin/commands', commands);
    return data as ChatCommand[];
  },
};
